export const getProjectTransactionTypes = (): string[] => [
  'Tenant Representation',
  'Buyer Representation',
  'Landlord Representation',
  'Seller Representation',
  'Corporate Services',
  'Consulting',
  'Investment Sale',
];
